// GENERATED AUTOMATICALLY
// DON NOT EDIT IT MANUALLY

import * as React from 'react';
import AntdIcon, { AntdIconProps } from '../components/AntdIcon';
import { IconDefinition } from '../types';

const ExternalOutlinedSvg: IconDefinition = {"icon":{"tag":"svg","attrs":{"fill":"currentColor","viewBox":"0 0 14 14","focusable":"false"},"children":[{"tag":"path","attrs":{"d":"M12.25 6.42a.58.58 0 00-.59.58v4.67H2.33V2.33H7a.58.58 0 000-1.16H1.75a.58.58 0 00-.59.58v10.5a.58.58 0 00.59.58h10.5a.58.58 0 00.58-.58V7a.58.58 0 00-.58-.58z","fill":"#39C2D7"}},{"tag":"path","attrs":{"d":"M12.47 1.21c-.2-.08-.08-.03-3.14-.04a.58.58 0 000 1.16h1.51L6.6 6.6a.58.58 0 10.82.82l4.26-4.25v1.5a.58.58 0 001.16 0c-.01-3.07.04-2.94-.04-3.13a.58.58 0 00-.32-.32z","fill":"#39C2D7"}}]},"name":"external","theme":"outlined"};

const ExternalOutlined = (
  props: AntdIconProps,
  ref: React.MutableRefObject<HTMLSpanElement>,
) => <AntdIcon {...props} ref={ref} icon={ExternalOutlinedSvg} />;
  ExternalOutlined.displayName = 'ExternalOutlined';

export default React.forwardRef<HTMLSpanElement, AntdIconProps>(ExternalOutlined);
